import { View } from "binder"
import { FormBuilderElement } from "../../element";
import { ComponentDropDecoratorViewModel } from "./componentDropDecorator-viewModel";

export class ComponentDropDecoratorView extends View<ComponentDropDecoratorViewModel>{
    GetViewUniqueId(): string {
        return "V-C5FCBE3B-9C74-4C40-98A2-AD0498F006F5"
    }
    loadHtml(): string {
        let element = require('./componentDropDecorator.html').default;
        let style = require('./componentDropDecorator.less');
        return element;
    }
    constructor() {
       super();
    }

    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;

}
